module.exports = __webpack_public_path__ + "img/alerts.6aab40bd.png";